import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import updateaction from "../../context/action/setting/updateaction";

const Setting = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
        useContext(GlobalContext);
    const [dollar_price, setdollar_price] = useState(initState.dollar_price || 0);
    const [error, seterror] = useState(false);
    return (
        <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-slate-800">ڕێکخستنەکانی سیستەم</h1>
                    <p className="text-sm text-slate-400 mt-0.5">بڕاوی سیستەمی سەرکارت</p>
                </div>
            </div>

            {/* Settings Form */}
            <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 items-end">
                <div className="w-full">
                    <label
                        className={
                        error
                            ? "block text-sm font-medium text-red-500 mb-1 text-right"
                            : "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                        htmlFor="dollar_price"
                    >
                        نرخی دۆلار
                    </label>
                    <input
                        className={
                        error
                            ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                            : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="dollar_price"
                        type="number"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={dollar_price}
                        onChange={(val) => setdollar_price(val.target.value)}
                        onFocus={() => seterror(false)}
                    />
                </div>
                <div className="w-full">
                    <button
                        className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                        onClick={() => {
                            if (dollar_price <=0 || !dollar_price) {
                            seterror(true);
                            return false;
                            }
                            updateaction(dollar_price)(recaller)(setrecaller)(initDispatch)(clear);
                        }}
                    >
                        گۆڕانکاری
                    </button>
                </div>
                {/* <div className="w-full">
                    <button
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-3 px-4 rounded h-12 w-full"
                        onClick={() => {
                            window.location.href = 'http://localhost/api/getBackup.php';
                        }}
                    >
                        داگرتنی باگ ئەپ
                    </button>
                </div> */}
            </div>
            </div>
        </div>
    )
}

export default Setting